import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../helper/Api";
import Toastify from "../helper/Toastify";
import { setUserRefresh } from "./userSlice";

const initialState = {
    isLoading: false,
    isRefresh: false,
    cartsData: {},
    updateCartsData: {},
    deleteCartsData: {},
    errorMsg: "",
    isError: false
}


export const getAllCarts = createAsyncThunk('getAllCarts', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.getAllCarts();
        if (status === 200) {
            //get categories data
            dispatch(setAllCarts(data.data))
        }
        return data.data
    } catch (err) {
        // Toastify.error(err.response.data.message)
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)

export const updateCarts = createAsyncThunk('updateCarts', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.updateCarts(body);

        if (status === 200) {
            // render otp screen
            dispatch(setUpdateCarts(body));
            // Toastify.success("Product updated successfuly");
            dispatch(setRefresh());
        }
        return data.data

    } catch (err) {
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)
export const deleteCarts = createAsyncThunk('deleteCarts', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.deleteCarts(body);

        if (status === 200) {
            // render otp screen
            dispatch(setDeleteCarts(body));
            // Toastify.success('Product deleted successfuly');
            dispatch(setRefresh());
        }
        return data.data

    } catch (err) {
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)

export const cartSlice = createSlice({
    name: "carts",
    initialState,
    reducers: {

        setAllCarts: (state, action) => {
            state.cartsData = action.payload
        },        
        setUpdateCarts: (state, action) => {
            state.updateCartsData = action.payload
        },
        setDeleteCarts: (state, action) => {
            state.deleteCartsData = action.payload
        },
        setRefresh: (state) => {
            state.isRefresh = !state.isRefresh
        },

    },
    extraReducers: (builder) => {

        // setAllProducts
        builder.addCase(getAllCarts.pending, (state) => {
            state.isLoading = true
            state.isError = false
        })
        builder.addCase(getAllCarts.fulfilled, (state, action) => {
            state.isLoading = false
            state.cartsData = action.payload
        })
        builder.addCase(getAllCarts.rejected, (state, action) => {
            state.isLoading = false
            state.errorMsg = action.payload
        })


    }
})

export const {
    setRefresh,
    setAllCarts,
    setUpdateCarts,
    setDeleteCarts
} = cartSlice.actions

export default cartSlice.reducer;